import api from '@/lib/api-client';

export type PresignRequestFile = {
  fileid: string;
  filename: string;
  size: number;
  mimetype: string;
};

export type PresignedFileInfo = {
  fileid: string;
  uploadUrl: string;
  bucket: string;
  key: string;
  filename: string;
  size: number;
  mimetype: string;
};

type PresignResponse = {
  files: PresignedFileInfo[];
};

type S3FileMeta = {
  bucket: string;
  key: string;
  filename: string;
  size: number;
  mimetype: string;
};

export type UpdateConfigurationPayload = {
  _id: string;
  vehicle: string;
  name: string;
  multiUnit: boolean;
  uploads: string; // JSON string of the permits (same as before)
  files: Record<string, S3FileMeta>; // fileid -> S3 metadata
};

export type CreateConfigurationPayload = {
  vehicle: string;
  name: string;
  multiUnit: boolean;
  uploads: string;
  files: Record<string, S3FileMeta>;
};

export async function presignUploads(
  files: PresignRequestFile[],
): Promise<PresignedFileInfo[]> {
  const data = (await api.post<PresignResponse>('/v1/admin/uploads/presign', {
      files,
  })) as unknown as PresignResponse;

  return data.files;
}
